var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.6C9.65217 5.6 9.30435 5.77409 9.13043 5.94819L3.3913 11.6933C2.86957 12.2155 2.86957 13.086 3.3913 13.6083C3.91304 14.1306 4.78261 14.1306 5.30435 13.6083L10 8.90777L14.6957 13.6083C15.2174 14.1306 16.087 14.1306 16.6087 13.6083C17.1304 13.086 17.1304 12.2155 16.6087 11.6933L11.0435 6.12228C10.6957 5.77409 10.3478 5.6 10 5.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevronUp.a94bed02ecd3e3f4fe368d7f798598f4.svg";
export { ForwardRef as ReactComponent };